import React from 'react';
import { Modal, ModalHeader, Row, Col, Card, CardBody } from 'reactstrap';
import { Link } from 'react-router-dom';
import {
    getStateSpecificAWSLogo as getAWSLogo,
    getStateSpecificNRLogo as getNRLogo,
    getStateSpecificAzureLogo as getAzureLogo,
    getStateSpecificGCPLogo as getGCPLogo, getStateSpecificDatadogLogo,
    getStateSpecificSplunkLogo,
    getStateSpecificADLogo as getADLogo, getDynatraceLogo, getOciLogo, getGrafanaLogo, getSignozLogo

} from "../../../helpers/component_helpers";
import { service_names as SERVICE_NAMES } from '../../../constants/data_types'

function DefaultAlertsModal({ type, isOpen, checkBox, filteredResources, handleCheckBox, cancelDeployModal, startLoading2, handleDeploy, linkTo }) {
    return (
        <Modal isOpen={isOpen} role="dialog" autoFocus={true} keyboard={false} centered backdrop="static" size="xl" data-toggle="modal">
            <div>
                <ModalHeader className="border-bottom-2">
                    <span className="modal-header-resource">Deploy Default Alerts</span>
                </ModalHeader>
            </div>
            <div className="modal-body">
                <Row className="full-width">
                    <Col lg="7" className="mt-4">
                        <Row>
                            {Object.keys(checkBox).map((key, index) => {
                                if (checkBox[key] === true) {
                                    return (
                                        <Col md="6" key={key}>
                                            <div className="border border-white text-white px-2 my-1 rounded-lg">
                                                {type === "AWS" && (
                                                    filteredResources[key].application_service_id === null ?
                                                        <div className="topleft"><i className="bx info-icon bx-info-circle bx-sm"
                                                            data-toggle="tooltip" data-placement="right"
                                                            title="Please map the resource to a service to deploy"></i>
                                                        </div>
                                                        : null
                                                )}
                                                <CardBody className="p-0">
                                                    <div className="resource-logo-display align-items-center">
                                                        <img src={type === "AWS" ? getAWSLogo(
                                                            filteredResources[key].resource_name, filteredResources[key].state) : type === "GCP" ? getGCPLogo(filteredResources[key].resource_name, filteredResources[key].state)
                                                            :type==='Azure' ? getAzureLogo(filteredResources[key].resource_name, filteredResources[key].state)
                                                                :type === "Datadog" ? getStateSpecificDatadogLogo(filteredResources[key].resource_name, true)
                                                                    :type === "Splunk" ? getStateSpecificSplunkLogo(filteredResources[key].resource_name, true)
                                                                        : type=== "NewRelic" ? getNRLogo(filteredResources[key].resource_name, filteredResources[key].is_application_active)
                                                                            :type === 'Dynatrace' ? getDynatraceLogo(filteredResources[key].resource_name, true)
                                                                                :type === 'OCI'? getOciLogo(filteredResources[key].resource_name)
                                                                                    :type === 'Grafana' ? getGrafanaLogo(filteredResources[key].resource_name, true)
                                                                                        :type === 'Signoz' ? getSignozLogo(filteredResources[key].resource_name, true)
                                                                                        :type==='AppDynamics'? getADLogo(filteredResources[key].resource_name, true):null} className="resource-logo mt-1" alt="Resource Logo" />
                                                        <h6 className="pt-2 resource-name-truncate">{filteredResources[key].name}</h6>
                                                    </div>
                                                </CardBody>
                                                <span className="close me-2" onClick={() => handleCheckBox(key)}></span>
                                            </div>
                                        </Col>
                                    );
                                }
                            })}
                        </Row>
                    </Col>
                    <Col lg="5" className="mt-4">
                        <div className="text-center mb-4">
                            <div className="row justify-content-center">
                                <div className="col-xl-10">
                                    <h4 className="text-primary">Are you sure you want to deploy these alerts?</h4>
                                    <h6 className="mt-4">
                                        This will deploy ALL the default alerts for the selected resources. Please review the{' '}
                                        <Link to={linkTo} target="_blank">
                                            default thresholds
                                        </Link>{' '}
                                        and modify, if required.
                                    </h6>
                                    <Row className="full-width">
                                        <Col lg="6" className="mt-4">
                                            <Link onClick={(event) => {
                                                event.preventDefault()
                                                cancelDeployModal()
                                            }} className="btn btn-secondary w-md">
                                                Cancel
                                            </Link>
                                        </Col>
                                        <Col lg="6" className="mt-4">
                                            <Link className="btn btn-primary w-md" onClick={(event) => {
                                                event.preventDefault()
                                                startLoading2();
                                                handleDeploy();
                                            }}>
                                                Deploy
                                            </Link>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </Modal>
    );
}

export default DefaultAlertsModal;